
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import EditBreakpoint from "./EditBreakpoint.vue";
import { addOrUpdateBreakpoint } from "@/lib/breakpoints/breakpoints";
import { Breakpoint } from "@/types/breakpoints";
import defensiveCopy from "@/util/defensive-copy";
import Icon from "@/components/UI/Icon.vue";
import EmptyStatePreferences from "@/components/Settings/Preferences/EmptyStatePreferences.vue";
import IconButton from "@/components/UI/IconButton.vue";

@Component({
  components: {
    Icon,
    EditBreakpoint,
    EmptyStatePreferences,
    TextInput,
    IconButton
  }
})
export default class EditBreakpoints extends Vue {
  @Prop()
  value!: Breakpoint[];

  editingBreakpointId = "";
  showAddForm = false;

  edit(breakpointId: string) {
    this.editingBreakpointId = breakpointId;
    this.showAddForm = false;
  }

  openAddBreakpointForm() {
    this.showAddForm = true;
    this.editingBreakpointId = "";
  }

  toggleAddBreakpointForm() {
    this.showAddForm = !this.showAddForm;
  }

  newBreakpointLabel: string | undefined = "";

  addBreakpoint() {
    if (!this.newBreakpointLabel) {
      return;
    }

    const normalizedBreakpointLabel = this.newBreakpointLabel
      .toLowerCase()
      .replace(/[- ]/g, "_");
    const newBreakpointId = `custom_breakpoint_${normalizedBreakpointLabel}`;

    this.updateOrAddBreakpoint({
      id: newBreakpointId,
      label: this.newBreakpointLabel,
      minWidth: undefined,
      maxWidth: undefined,
      defaultPreviewWidth: "100%"
    });
  }

  deleteBreakpoint(breakpointId: string) {
    const newBreakpoints = defensiveCopy(this.value);
    const index = newBreakpoints.findIndex(b => b.id === breakpointId);
    newBreakpoints.splice(index, 1);
    this.$emit("input", newBreakpoints);
  }

  updateOrAddBreakpoint(newBreakpoint: Breakpoint) {
    const newBreakpoints = addOrUpdateBreakpoint(this.value, newBreakpoint);
    this.$emit("input", newBreakpoints);

    if (this.showAddForm === true) this.showAddForm = false;
    this.newBreakpointLabel = "";
  }
}
